import { Controller, Payload } from "../../controller";
import { ApplicationState } from "../../store";
import { bindActionCreators, Dispatch } from "redux";
import { Cliente ,initialValueState, ClienteState, ClienteActions } from "./cliente.model"

export interface ClienteViewProps{
    clienteState:ClienteState
    clienteActions:ClienteActions
}

class ClienteController extends Controller<Cliente, ClienteState, ClienteActions> {
    constructor() {
        super(initialValueState.row.type,initialValueState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
        ]
    }

    private* novoActionEffects(actions:Payload){

    }
}

export const clienteController = new ClienteController()

export const mapStateToClienteProps = (state: ApplicationState) => ({
    clienteState: state.clienteState,
})

export const mapDispatchToClienteProps = (dispatch: Dispatch) => ({
    clienteActions: bindActionCreators({...clienteController.reducer.actions}, dispatch),
})